export default __webpack_public_path__ + "static/media/mail_white.f8f733ab.svg";